var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSolidClouds = function SvgSolidClouds(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 440,
    height: 32,
    viewBox: "0 0 440 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5608_18367)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M0 32V19.656C17.523 13.736 37.983 11.0773 57.9333 12.1893C83.732 13.6213 107.921 21.072 133.76 22.1893C160.835 23.352 187.858 17.688 213.767 12.7867C239.166 7.98666 264.477 6.152 290.547 9.29867C303.802 10.8987 316.158 14.056 328.845 17.1227C362.813 25.3333 408.1 35.8107 440 18.008V32H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M0 32V27.784C4.76667 22.1547 10.1347 16.8373 17.4863 12.7867C36.4503 2.328 60.5 2.4 82.346 7.57867C93.7677 10.2853 104.379 14.5307 115.225 18.192C130.229 23.2587 146.293 30.4587 163.196 31.4373C176.491 32.1973 189.193 28.9253 199.349 23.0213C210.998 16.2507 222.2 6.488 237.347 3.55467C252.175 0.677336 267.175 5.33867 281.028 10.0293C294.881 14.72 308.587 20.4293 323.899 21.5093C345.8 23.0693 365.435 15.408 385.829 11.152C396.902 8.84267 407.462 9.50667 417.762 13.152C425.986 16.056 435.362 20.3333 440 26.2827V32H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 32V30.4987C54.9743 16.2667 115.166 12.9813 174.471 20.648C190.238 22.6853 205.355 26.0133 221.261 27.704C242.895 30.0053 262.504 24.44 281.967 18.264C303.574 11.408 324.867 6.60266 348.773 8C380.501 9.86666 412.009 20.1893 440 30.616V32H0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5608_18367"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 440,
    height: 32,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 32)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSolidClouds);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "solid-clouds.9038eb1a86c9260dcd2bfd0570c08729.svg";